<template>
  <body>
    <Header headerColor="black" />
    <LearnWhyContent />
    <Footer />
  </body>
</template>

<script>
import LearnWhyContent from "@/components/LearnWhy/LearnWhyContent.vue";
import Header from "@/components/SharedComponents/Header.vue";
import Footer from "@/components/SharedComponents/Footer.vue";

export default {
  name: "sustainability",
  components: {
    Header,
    LearnWhyContent,
    Footer,
  },
};
</script>
